import { render, staticRenderFns } from "./CustomerFilterModal.vue?vue&type=template&id=38aa8884&scoped=true"
import script from "./CustomerFilterModal.vue?vue&type=script&lang=js"
export * from "./CustomerFilterModal.vue?vue&type=script&lang=js"
import style0 from "./CustomerFilterModal.vue?vue&type=style&index=0&id=38aa8884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aa8884",
  null
  
)

export default component.exports